/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { useState, useEffect } from "react";
// javascipt plugin for creating charts
import Chart from "chart.js";
// reactstrap components

// core components
import {
  chartOptions,
  parseOptions,
} from "dashboard/general-management/variables/charts.js";

import Header from "dashboard/general-management/components/Headers/Header.js";
import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
  Progress,
  CardImg,
  Button,
  UncontrolledTooltip,
} from "reactstrap";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css"; // Import the default calendar styles
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css"; // Import the styles
import { api } from "../../../api";
import Cookies from 'js-cookie';


const calendarCustomStyle = `
.react-calendar__tile--active,
.react-calendar__tile--range,
.react-calendar__tile--rangeStart,
.react-calendar__tile--rangeEnd {
  background: #d86f89 !important;
  color: #fff !important;
}
`;

const getImagePath = (imageName) => {
  if (!imageName) return '/images/default-profile.png';
  return `/images/${imageName}`;
};

const Index = (props) => {
  const [activeNav, setActiveNav] = useState(1);
  const [chartExample1Data, setChartExample1Data] = useState("data1");

  if (window.Chart) {
    parseOptions(Chart, chartOptions());
  }

  const toggleNavs = (e, index) => {
    e.preventDefault();
    setActiveNav(index);
    setChartExample1Data("data" + index);
  };
  const [date, setDate] = useState(new Date());
  const [selectedDateLabel, setSelectedDateLabel] = useState("");
  const [isBirthday, setIsBirthday] = useState(false);
  const [timeOfDay, setTimeOfDay] = useState("");

  const getFormattedDateLabel = (date) => {
    return `${date.toLocaleString("default", {
      month: "long",
    })} ${date.getDate()}, ${date.getFullYear()}`;
  };

  const checkBirthday = (date) => {
    return date.getMonth() === 0 && date.getDate() === 1;
  };

  const getTimeOfDay = (date) => {
    const hour = date.getHours();

    if (hour >= 0 && hour < 12) {
      return "Morning🌞";
    } else if (hour >= 12 && hour < 18) {
      return "Afternoon⛅";
    } else {
      return "Night🌙";
    }
  };

  const emp_id = Cookies.get('token');

  useEffect(() => {
    const label = getFormattedDateLabel(date);
    setSelectedDateLabel(label);
    setIsBirthday(checkBirthday(date));
    setTimeOfDay(getTimeOfDay(date));
  }, [date]);

  const [project, setproject] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const company_id = Cookies.get('company_id');
        const emp_id = Cookies.get('emp_id');
        const response = await api.get(
          `viewProjectDetails.php?g_m_id=${emp_id}&company_id=${company_id}`
        );
        setproject(response.data);
        console.log(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  console.log(project);

  const [employees, setEmployees] = useState([]);
  const fetchEmployeeName = async () => {
    try {
      const company_id = Cookies.get('company_id');
      const response = await api.get(`employeeCalendar.php?company_id=${company_id}`);
      setEmployees(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchEmployeeName();
  },[]);

  useEffect(() => {
    const label = getFormattedDateLabel(date);
    setSelectedDateLabel(label);
    setTimeOfDay(getTimeOfDay(date));
  }, [date, employees]);

  const isEmployeeBirthday = (date, employee) => {
    const employeeDOB = new Date(employee.dob);
    return (
      date.getDate() === employeeDOB.getDate() &&
      date.getMonth() === employeeDOB.getMonth()
    );
  };

  const isEmployeeWorkAnniversary = (date, employee) => {
    const anniversaryDate = new Date(employee.doj);
    return (
      date.getDate() === anniversaryDate.getDate() &&
      date.getMonth() === anniversaryDate.getMonth()
    );
  };
  return (
    <>
      <Header />
      {/* Page content */}
      <div className="header bg-gradient-info py-8 py-lg-6">
        <Container fluid>
          <Row className="mt-0">
            <Col lg="8">
              {" "}
              {/* Adjust the column size to your preference */}
              {/* Your existing cards */}
              <Card className="card-stats mb-4 mb-xl-0 m-0" style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',backgroundColor: '#fff',borderRadius: '15px'}}>
                <CardBody>
                  <Row>
                    <h1>Overview</h1>
                  </Row>
                </CardBody>
              </Card>
              {Array.isArray(project) && project.length > 0 ? (
                project.map(project => (
                  <Card key={project.projectId || project.p_id} className="card-stats mb-4 mb-xl-0 p-2 mt-3" style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',backgroundColor: '#fff',borderRadius: '15px'}}>
                    <CardBody>
                      <Row>
                        {/* Circular Progress Bar on the Left */}
                        <Col xs="3" className="text-center">
                          <div style={{ width: '80px', height: '80px' }}>
                            <CircularProgressbar
                              value={project.progress || project.project_progress}
                              text={`${project.progress || project.project_progress || 0}%`}
                              styles={buildStyles({
                                textColor: 'blue',
                                pathColor: '#007bff',
                                trailColor: '#eee',
                              })}
                            />
                          </div>
                        </Col>

                        <Col xs="6" className="text-center">
                          <h3>{project.projectName || project.p_name}</h3>
                          <p>About: {project.description || project.p_description || "No description available"}</p>
                        </Col>

                        <Col xs="3" className="d-flex justify-content-end">
                          <div className="avatar-group d-flex">
                            {project.profile && project.profile.images && project.profile.images.map && project.profile.images.map((image, index) => (
                              <div className="avatar-group " style={{height:'40px', width:'25px'}}  key={index}>
                                <button
                                  className="avatar avatar-sm "
                                  id={`tooltip-${project.projectId || project.p_id}-${index}`}
                                  onClick={(e) => e.preventDefault()}
                                  style={{ border: 'none', background: 'none', padding: 0 }}
                                >
                                  <img
                                    alt={`Profile ${index}`}
                                    className="rounded-circle"
                                    style={{height:'35px', width:'35px'}}
                                    src={getImagePath(image)}
                                    onError={e => {
                                      e.target.onerror = null;
                                      e.target.src = getImagePath();
                                    }}
                                  />
                                </button>
                                <UncontrolledTooltip delay={0} target={`tooltip-${project.projectId || project.p_id}-${index}`}>
                                  {project.profile.full_names && project.profile.full_names[index]}
                                </UncontrolledTooltip>
                              </div>
                            ))}
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                ))
              ) : (
                <div className='mt-4' style={{textAlign: 'center'}}>No projects available</div>
              )}
            </Col>
            <Col lg="4">
            <Card
                className="card-stats mb-4 mb-xl-0"
                style={{
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                  padding: '1rem',
                  margin: 0,
                  width: '100%',
                  maxWidth: 420,
                  minWidth: 0,
                  alignSelf: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <CardBody style={{ padding: 0, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <Row style={{ margin: 0, width: '100%', justifyContent: 'center' }}>
                    <div className="col" style={{ textAlign: 'center' }}>
                      <CardTitle
                        tag="h3"
                        className="text-uppercase text-muted mb-0"
                        style={{ marginBottom: '0.5rem' }}
                      >
                        Calendar
                      </CardTitle>
                    </div>
                  </Row>
                  <Row style={{ margin: 0, width: '100%', justifyContent: 'center' }}>
                    <Col className="col-auto mt-2" style={{ padding: 0, width: '100%', display: 'flex', justifyContent: 'center' }}>
                      <div style={{ width: '100%', maxWidth: 340, minWidth: 0, display: 'flex', justifyContent: 'center' }}>
                        <Calendar
                          style={{ width: '100%' }}
                          onChange={setDate}
                          value={date}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col>
                      <p>Selected Date: {selectedDateLabel}</p>
                      {isBirthday && (
                        <div>
                          <Row>
                            <Col className="col-auto">
                              {/* Add the image on one side */}
                              <img
                                src={getImagePath('birthday_image.jpg')}
                                alt="Birthday"
                                style={{
                                  width: "100px", // Set the width of the image
                                  height: "100px", // Set the height of the image
                                  borderRadius: "50%", // Make it a circular image
                                }}
                              />
                            </Col>
                          </Row>
                        </div>
                      )}
                      <style>{calendarCustomStyle}</style>
                      {timeOfDay && (
                        <p
                          className="text-center p-3"
                          style={{
                            fontWeight: "bold",
                            color: "#000",
                            backgroundColor: "#d86f89",
                            borderRadius: "0.375rem",
                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          Good {timeOfDay}
                        </p>
                      )}
                    </Col>
                  </Row>

                  {/* Birthday and Anniversary */}

                  {employees.some(
                    (employee) =>
                      isEmployeeBirthday(date, employee) ||
                      isEmployeeWorkAnniversary(date, employee)
                  ) && (
                    <>
                      {employees.map((employee, index) => {
                        if (
                          isEmployeeBirthday(date, employee) &&
                          isEmployeeWorkAnniversary(date, employee)
                        ) {
                          return (
                            <Row
                              key={index}
                              style={{
                                border: "2px solid #ddd",
                                borderRadius: "10px",
                                padding: "20px",
                                backgroundColor: "#fff",
                                boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                                marginBottom: "10px",
                              }}
                            >
                              <Col xs={3} className="text-center">
                                <img
                                  src={getImagePath(employee.profile_image)}
                                  alt="Birthday & Work Anniversary"
                                  style={{
                                    width: "80px",
                                    height: "80px",
                                    borderRadius: "50%",
                                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                                  }}
                                  onError={e => {
                                    e.target.onerror = null;
                                    e.target.src = getImagePath();
                                  }}
                                />
                              </Col>
                              <Col>
                                <p
                                  style={{
                                    fontSize: "bold",
                                    color: "#333",
                                    marginBottom: "10px",
                                    textAlign: "center",
                                  }}
                                >
                                  🎉Happy Birthday & Work Anniversary!🎉
                                </p>
                                <p
                                  style={{
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    fontSize: "18px",
                                    color: "#666",
                                    marginBottom: "5px",
                                  }}
                                >
                                  {employee.emp_name}
                                </p>
                                <p
                                  style={{
                                    marginTop: "10px",
                                    fontSize: "16px",
                                    color: "#555",
                                    textAlign: "center",
                                  }}
                                >
                                  Double celebration! Wishing you a day filled
                                  with joy, laughter, and all the things you
                                  love.
                                </p>
                              </Col>
                            </Row>
                          );
                        } else if (isEmployeeBirthday(date, employee)) {
                          return (
                            <Row
                              key={index}
                              style={{
                                border: "2px solid #ddd",
                                borderRadius: "10px",
                                padding: "20px",
                                backgroundColor: "#fff",
                                boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                                marginBottom: "10px",
                              }}
                            >
                              <Col xs={3} className="text-center">
                                <img
                                  src={getImagePath(employee.profile_image)}
                                  alt="Birthday"
                                  style={{
                                    width: "80px",
                                    height: "80px",
                                    borderRadius: "50%",
                                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                                  }}
                                  onError={e => {
                                    e.target.onerror = null;
                                    e.target.src = getImagePath();
                                  }}
                                />
                              </Col>
                              <Col>
                                <p
                                  style={{
                                    fontSize: "bold",
                                    color: "#333",
                                    marginBottom: "10px",
                                    textAlign: "center",
                                  }}
                                >
                                  🎉Happy Birthday!🎉
                                </p>
                                <p
                                  style={{
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    fontSize: "18px",
                                    color: "#666",
                                    marginBottom: "5px",
                                  }}
                                >
                                  {employee.emp_name}
                                </p>
                                <p
                                  style={{
                                    marginTop: "10px",
                                    fontSize: "16px",
                                    color: "#555",
                                    textAlign: "center",
                                  }}
                                >
                                  Wishing you a day filled with joy, laughter,
                                  and all the things you love!
                                </p>
                              </Col>
                            </Row>
                          );
                        } else if (isEmployeeWorkAnniversary(date, employee)) {
                          return (
                            <Row
                              key={index}
                              style={{
                                border: "2px solid #ddd",
                                borderRadius: "10px",
                                padding: "20px",
                                backgroundColor: "#fff",
                                boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                                marginBottom: "10px",
                              }}
                            >
                              <Col xs={3} className="text-center">
                                <img
                                  src={getImagePath(employee.profile_image)}
                                  alt="Work Anniversary"
                                  style={{
                                    width: "80px",
                                    height: "80px",
                                    borderRadius: "50%",
                                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                                  }}
                                  onError={e => {
                                    e.target.onerror = null;
                                    e.target.src = getImagePath();
                                  }}
                                />
                              </Col>
                              <Col>
                                <p
                                  style={{
                                    fontSize: "bold",
                                    color: "#333",
                                    marginBottom: "10px",
                                    textAlign: "center",
                                  }}
                                >
                                  🎉Congratulations on your work anniversary!🎉
                                </p>
                                <p
                                  style={{
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    fontSize: "18px",
                                    color: "#666",
                                    marginBottom: "5px",
                                  }}
                                >
                                  {employee.emp_name}
                                </p>
                                <p
                                  style={{
                                    marginTop: "10px",
                                    fontSize: "16px",
                                    color: "#555",
                                    textAlign: "center",
                                  }}
                                >
                                  It's been a pleasure having you on the team.
                                  Your hard work and dedication are appreciated.
                                </p>
                              </Col>
                            </Row>
                          );
                        } else {
                          return null;
                        }
                      })}
                    </>
                  )}

                  {/* ... Your existing code ... */}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Index;
